import { Alert, Stack, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import DialogButton from '../../../Common/Buttons/DialogButton'
import Dialog from '../../../Common/Dialog/Dialog'
import DialogActions from '../../../Common/Dialog/DialogActions'
import DialogContent from '../../../Common/Dialog/DialogContent'
import DialogTitle from '../../../Common/Dialog/DialogTitle'
import { useAppDispatch } from '../../../Common/_hooks/useAppDispatch'
import { useAppSelector } from '../../../Common/_hooks/useAppSelector'
import { BatchUnsyncStoreProducts, type BatchStoreProductSelection } from '../../../UserData/_actions/Store/StoreProductActions'
import { ClearStoreSelectedProduct } from '../../../UIData/_actions/Account/AccountStoreActions'

interface Props {
  opened: boolean
  storeType: string
  selection: BatchStoreProductSelection
  selectionCount: number
  onClose: () => void
}

export default function BatchUnsyncStoreProductsDialog(props: Props) {
  const [t] = useTranslation('account-v2')
  const dispatch = useAppDispatch()
  const loader = useAppSelector(state => state.get('UIData').get('loaders').get('edit_store_products'))

  const onConfirm = useCallback(() => {
    dispatch(BatchUnsyncStoreProducts(props.storeType, props.selection).set({
      onSuccess: () => {
        dispatch(ClearStoreSelectedProduct())
        props.onClose()
      }
    }))
  }, [dispatch, props])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{t('Unsync {{count}} products', { count: props.selectionCount })}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        <Typography variant="body1">{t('This will unsync the selected products from Art of Where.')}</Typography>
        <Alert severity="info">{t('If you never want these products to be imported in future orders, you should instead use the "Ignore" feature.')}</Alert>
      </Stack>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        disabled={!!loader}
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="primary"
        disabled={!!loader}
        onClick={onConfirm}
        autoFocus
      >{t('Unsync')}</DialogButton>
    </DialogActions>
  </Dialog>
}
